import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import LoadingWrapper from 'components/Common/LoadingWrapper';
import ModalWrapper from '../ModalWrapper';

class WithholdingRatesModal extends Component {
  static propTypes = {
    isShown: PropTypes.bool.isRequired,
    isGettingAccountWithholding: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    accountWithholding: PropTypes.shape()
  };

  static defaultProps = {
    isGettingAccountWithholding: false,
    accountWithholding: null
  }

  render() {
    const {
      isShown,
      onClose,
      isGettingAccountWithholding,
      accountWithholding
    } = this.props;
    function dateFormatter(value, format) {
      return moment(value).format(format);
    }

    function getEffectiveDate(withholding) {
      if (withholding && withholding.effectiveDate !== null) {
        return `${ dateFormatter(withholding.effectiveDate, 'MMM DD, YYYY') }`;
      }
      return '';
    }

    function getSystemDate(withholding) {
      if (withholding && withholding.systemDate !== null) {
        return `${ dateFormatter(withholding.systemDate, 'MMM DD, YYYY') }`;
      }
      return '';
    }

    function getFatcaCompliant(withholding) {
      let fatcaCompliant = '';
      if (withholding != null && withholding.fatcaCompliant != null) {
        fatcaCompliant = `${ withholding.fatcaCompliant ? 'Yes' : 'No' }`;
        if (withholding.chapter4Status != null) {
          fatcaCompliant += ` ${ withholding.chapter4Status ? `(${ withholding.chapter4Status })` : '(NA)' }`;
        }
        return fatcaCompliant;
      }
      return 'NA';
    }

    function getTreatyEligible(withholding) {
      if (!withholding) {
        return 'NA';
      }

      let treatyCountry = '(NA)';
      if (withholding.treatyCountryName) {
        treatyCountry = `(${ withholding.treatyCountryName })`;
      } else if (withholding.taxCountryName) {
        treatyCountry = `(${ withholding.taxCountryName })`;
      }

      if (withholding.treatyEligible === null) {
        return treatyCountry;
      }

      return `${ withholding.treatyEligible ? 'Yes' : 'No' } ${ treatyCountry }`;
    }

    function getRate(rate) {
      if (rate.nra) {
        return `${ parseFloat(rate.nra * 100).toFixed(4) }%`;
      }
      if (rate.backup) {
        return `${ parseFloat(rate.backup * 100).toFixed(4) }%`;
      }
      if (rate.fatca) {
        return `${ parseFloat(rate.fatca * 100).toFixed(4) }%`;
      }
      return `${ parseFloat(0).toFixed(4) }%`;
    }

    return (
      <ModalWrapper
        isOpen={ isShown }
        title={ `Withholding Rates as of ${ getSystemDate(accountWithholding) }` }
        btnCancelTitle="Close"
        onCancel={ onClose }
        showFooter={ false }
        modalSize="modal-lg whd-rates-modal"
      >
        { isGettingAccountWithholding && <LoadingWrapper loaded={ !isGettingAccountWithholding } /> }
        { !isGettingAccountWithholding && accountWithholding && <div>

          <div className="form-group">
            <div className="col-2">
              <label className="form-label">Account Number:</label>
            </div>
            <div className="col-10">
              <span>{ `${ accountWithholding.accountNumber }` }</span>
            </div>
          </div>
          <div className="form-group">
            <div className="col-2">
              <label className="form-label">Account Name:</label>
            </div>
            <div className="col-10">
              <span>{ `${ accountWithholding.accountName }` }</span>
            </div>
          </div>
          { accountWithholding.accountRates != null && <table className="table table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th className="col-3">Income Type</th>
                <th className="col-3">Withholding Type</th>
                <th className="col-2">Rate</th>
                <th className="col-2">State - California</th>
                <th className="col-2">State - Maine</th>
              </tr>
            </thead>
            <tbody>
              { (accountWithholding.accountRates != null) && (accountWithholding.accountRates).map((acctRate, acctRateIndex) => (
                <tr key={ acctRate.id }>
                  <td>{ acctRate.incomeTypeDescription }</td>
                  <td>{ acctRate.whdTypeDescription }</td>
                  <td>{ getRate(acctRate) }</td>
                  <td>{ `${ parseFloat(acctRate.stateCalifornia * 100).toFixed(4) }%` }</td>
                  <td>{ `${ parseFloat(acctRate.stateMaine * 100).toFixed(4) }%` }</td>
                </tr>
              )) }
            </tbody>
          </table> }
          <hr />
          <hr />
          <hr />
            { accountWithholding.itemWithholdingRates && <div>
              { (accountWithholding.itemWithholdingRates).map((item, index) => (
                <div key={ item.customerId }>
                  <div className="form-group">
                    <div className="col-6">
                      <div className="form-group">
                        <div className="col-4">
                          <label className="form-label">Customer:</label>
                        </div>
                        <div className="col-8">
                          <span>{ `${ item.customerId } - ${ item.customerName }` }</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <div className="col-4">
                          <label className="form-label">Documented:</label>
                        </div>
                        <div className="col-8">
                          <span>{ `${ item.isDocumented ? 'Yes' : 'No' }` }</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-6">
                      <div className="form-group">
                        <div className="col-4">
                          <label className="form-label">US FDAP:</label>
                        </div>
                        <div className="col-8">
                          <span>{ `${ item.isOnshore ? 'Yes' : 'No' }` }</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <div className="col-4">
                          <label className="form-label">FATCA Compliant:</label>
                        </div>
                        <div className="col-8">
                          <span>{ getFatcaCompliant(item) }</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-6">
                      <div className="form-group">
                        <div className="col-4">
                          <label className="form-label">Customer Type:</label>
                        </div>
                        <div className="col-8">
                          <span>{ `${ item.customerType }` }</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <div className="col-4">
                          <label className="form-label">Treaty Eligible:</label>
                        </div>
                        <div className="col-8">
                          <span>{ getTreatyEligible(item) }</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-6">
                      <div className="form-group">
                        <div className="col-4">
                          <label className="form-label">Effective Date:</label>
                        </div>
                        <div className="col-8">
                          <span>{ getEffectiveDate(item) }</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  { item.isComplete && item.rates && <table className="table table-bordered table-striped table-hover">
                    <thead>
                      <tr>
                        <th className="col-3">Income Type</th>
                        <th className="col-3">Withholding Type</th>
                        <th className="col-2">Rate</th>
                        <th className="col-2">State - California</th>
                        <th className="col-2">State - Maine</th>
                      </tr>
                    </thead>
                    <tbody>
                      { (item.rates).map((rate, rateIndex) => (
                        <tr key={ rate.id }>
                          <td>{ rate.incomeTypeDescription }</td>
                          <td>{ rate.whdTypeDescription }</td>
                          <td>{ getRate(rate) }</td>
                          <td>{ `${ parseFloat(rate.stateCalifornia * 100).toFixed(4) }%` }</td>
                          <td>{ `${ parseFloat(rate.stateMaine * 100).toFixed(4) }%` }</td>
                        </tr>
                      )) }
                    </tbody>
                  </table> }
                  { !item.isComplete && <div className="no-rates">
                    <h2>{ item.resultMessage }</h2>
                    </div> }
                  <hr />
                </div>
              )) } </div> }
          </div> }
      </ModalWrapper>
    );
  }
}

function mapStateToProps(state) {
  const { forms: {
    isGettingAccountWithholding,
    accountWithholding
  } } = state;

  return {
    isGettingAccountWithholding,
    accountWithholding
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithholdingRatesModal);
